import { render, staticRenderFns } from "./MeterialDetail.vue?vue&type=template&id=6b1f02d6&scoped=true"
import script from "./MeterialDetail.vue?vue&type=script&lang=js"
export * from "./MeterialDetail.vue?vue&type=script&lang=js"
import style0 from "./MeterialDetail.vue?vue&type=style&index=0&id=6b1f02d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1f02d6",
  null
  
)

export default component.exports